import { render, staticRenderFns } from "./QuizCreatorLoader.vue?vue&type=template&id=e8cf461c&"
import script from "./QuizCreatorLoader.vue?vue&type=script&lang=js&"
export * from "./QuizCreatorLoader.vue?vue&type=script&lang=js&"
import style0 from "./QuizCreatorLoader.vue?vue&type=style&index=0&id=e8cf461c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports